<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" [attr.viewBox]="'0 0 ' + SVG_WITH + ' 850'" #svg class="result-image" [class.internal]="internalPortal">
  <style type="text/css">
    .headline {
    font-size: 36px;
  }

  text {
  font-size: 30px;
  fill: #202020;
  user-select: none;
}

.subheadline {
font-size: 28px;
}

.bold {
font-weight: bold;
}

.white {
fill: #ffffff;
}

.st2 {
opacity: 0.5;
fill: #FFFFFF;
}

.st3 {
opacity: 0.2;
fill: #FFFFFF;
}

.st4 {
fill: #FFFFFF;
}

.line {
fill: none;
stroke: #FBBA00;
stroke-width: 5;
stroke-linejoin: round;
}

.arrow {
fill: #FBBA00;
}

.st13 {
fill: none;
stroke: #FFFFFF;
stroke-width: 2;
stroke-linecap: round;
stroke-linejoin: round;
stroke-miterlimit: 10;
}

.st17 {
fill: none;
stroke: #FFFFFF;
stroke-width: 3;
stroke-miterlimit: 10;
}

.st21 {
fill: none;
stroke: #FFFFFF;
stroke-width: 4.24;
stroke-miterlimit: 10;
}

.anlage-background {
stroke-width: 0;

}

.anlage-volleinspeisung {
stroke: #ffffff;
stroke-width: 3px;
}

.anlage-eigennutzung {
stroke: #ffffff;
stroke-width: 3px;
}

.st27 {
fill: none;
stroke: #FFFFFF;
stroke-width: 2;
stroke-miterlimit: 10;
}

.thumb-background, .resize {
fill:#ffffff;
fill-opacity:1;
fill-rule:nonzero;
stroke:none;
cursor: move;
}

.thumb, .resize-background {
fill:#fe1a69;
fill-opacity:1;
fill-rule:nonzero;
stroke:none;
cursor: move;
}

.resize-background, .resize {
cursor: pointer;
}

.drag, .disabled {
opacity: .5;
}
</style>
<g>
  <g>
    <g>
      <rect x="712.9" y="3" class="st0" width="82.1" height="136.1"/>
      <polygon class="st0" points="946.9,33.5 13.1,33.5 1.9,340.7 958.9,340.7"/>
      <polygon class="st1" points="926,57.6 30.1,57.6 24.9,320.1 931.5,320.1"/>
      <g>
        <polygon class="st2" points="172.8,320.1 185.9,320.1 215.6,58 202.5,58	"/>
        <polygon class="st2" points="328.2,320.1 340.3,320.1 360.1,58 348,58	"/>
        <polygon class="st2" points="810.7,320.1 798.7,320.1 765.7,58 777.8,58	"/>
        <polygon class="st2" points="669.6,320.1 657.5,320.1 632.2,58 644.3,58	"/>
        <polygon class="st2" points="520.7,320.1 508.6,320.1 498.7,58 510.8,58	"/>
      </g>
      <g>
        <rect x="38" y="326.6" class="st0" width="877" height="43.2"/>
        <g>
          <g>
            <rect x="216.3" y="344.8" class="st2" width="111.7" height="25"/>
          </g>
          <g>
            <rect x="626.7" y="344.8" class="st2" width="111.7" height="25"/>
          </g>
        </g>
      </g>
      <polygon class="st0" points="932.9,191 25.9,191 25.9,178 931.9,178"/>
      <polygon class="st3" points="28.5,254.7 30.1,57.6 745,57.6"/>
    </g>
  </g>
    <path class="st4" d="M849.7,299.4H80.6c-5.5,0-10-4.5-10-10V86.1c0-5.5,4.5-10,10-10h769.1c5.5,0,10,4.5,10,10v203.3
		C859.6,294.9,855.2,299.4,849.7,299.4z"/>
  @if (deviceMatrix.eigennutzung.visible) {
    <g style="transform: translateY(40px)">
      <!-- line stromzukauf -->
      <line class="line" x1="874" y1="555.7" x2="185.8" y2="555.7"/>
      <polygon class="arrow" points="195.7,543.4 197.7,545.6 186.9,555.7 197.7,565.7 195.7,567.9 182.5,555.7	"/>
    </g>
  }
  @if (deviceMatrix.eigennutzung.visible) {
    <g>
      <!-- line ueberschusseinspeisung -->
      <polyline class="line" points="93,600 93,750 870,750 870,650"/>
      <polygon style="transform: matrix(1, 0, 0, 1, 0, 50)" class="arrow" points="882,610 880,612 870,601 860,612 858,610 870,597"/>
    </g>
  }
  <g style="transform: translateY(40px)">
    <!-- icon net -->
    <g>
      <g>
        <clipPath id="SVGID_00000117657091574260442330000011812232965490237364_">
          <circle cx="865.1" cy="497.7" r="93.7"/>>
        </clipPath>
        <circle class="st1" style="clip-path:url(#SVGID_00000117657091574260442330000011812232965490237364_);stroke:#FFFFFF;stroke-width:3.9401;stroke-miterlimit:10;" cx="865.1"
          cy="497.7" r="93.7"/>
      </g>
      <g>
        <clipPath id="SVGID_00000176007052331959127140000010597934395539634094_">
          <circle cx="865.1" cy="497.7" r="93.7"/>
        </clipPath>
        <circle style="clip-path:url(#SVGID_00000176007052331959127140000010597934395539634094_);fill:none;" cx="865.1" cy="497.7" r="93.7"/>
      </g>
      <g>
        <clipPath id="SVGID_00000013176015006355824280000006664390348475734951_">
          <circle cx="865.1" cy="497.7" r="93.7"/>
        </clipPath>
          <path style="clip-path:url(#SVGID_00000013176015006355824280000006664390348475734951_);" class="st0" d="M753,570.3
					c0,12.5,49.2,22.6,110,22.6c60.7,0,112-5.4,112-17.9s-51-24-129-25C785.3,549.2,753,557.8,753,570.3z"/>
      </g>
    </g>
    <g>
      <g>
        <clipPath id="SVGID_00000104672109599526958160000002070088217577824130_">
          <circle cx="865.1" cy="497.7" r="93.7"/>
        </clipPath>
          <path style="clip-path:url(#SVGID_00000104672109599526958160000002070088217577824130_);fill:none;stroke:#FBBA00;stroke-miterlimit:10;" d="
					M970.9,520.3c-7.8,12.7-76.1-7-76.1-7s-21.7-9.1-32.4-14.1c-24-11.3-49.3-24-49.3-24s-91.7,17.3-112.7-9.7"/>
      </g>
      <g>
        <clipPath id="SVGID_00000114074006294529337020000010394227953432210077_">
          <circle cx="865.1" cy="497.7" r="93.7"/>
        </clipPath>
          <path style="clip-path:url(#SVGID_00000114074006294529337020000010394227953432210077_);fill:none;stroke:#FBBA00;stroke-miterlimit:10;" d="
					M976.5,547.1c-28.4,2.5-84.6-14.1-84.6-14.1s-21.1-3.7-32.4-7c-33.8-9.9-50.8-14.1-50.8-14.1s-130.5,32.6-151.5,5.7"/>
      </g>
      <g>
        <clipPath id="SVGID_00000109748686397520447150000018255401510116614580_">
          <circle cx="865.1" cy="497.7" r="93.7"/>
        </clipPath>
        <g style="clip-path:url(#SVGID_00000109748686397520447150000018255401510116614580_);">
          <polyline class="st13" points="858.5,554.4 834.5,426.6 810.7,554.4		"/>
          <polygon class="st13" points="858.5,501.9 808.9,501.9 822.6,490.5 846.5,490.5		"/>
          <polygon class="st13" points="855.1,466.1 812.9,466.1 828,456.2 840,456.2		"/>
          <polyline class="st13" points="858.5,554.4 816.3,524.1 848.7,501.9		"/>
          <polyline class="st13" points="810.8,554.1 852.6,524 820.2,501.8		"/>
          <line class="st13" x1="841.9" y1="466.1" x2="822.6" y2="490.5"/>
          <line class="st13" x1="827.1" y1="466.1" x2="846.5" y2="490.5"/>
          <line class="st13" x1="855.1" y1="474.6" x2="855.1" y2="466.1"/>
          <line class="st13" x1="812.4" y1="474.6" x2="812.4" y2="466.1"/>
          <line class="st13" x1="859" y1="510.7" x2="859" y2="502.2"/>
          <line class="st13" x1="808.9" y1="510.7" x2="808.9" y2="502.2"/>
        </g>
      </g>
      <g>
        <clipPath id="SVGID_00000034086137526437007750000017873854589876249492_">
          <circle cx="865.1" cy="497.7" r="93.7"/>
        </clipPath>
        <g style="clip-path:url(#SVGID_00000034086137526437007750000017873854589876249492_);">
          <polyline class="st13" points="919.4,555.8 906.4,486.9 893.5,555.8		"/>
          <polygon class="st13" points="919.4,527.5 892.6,527.5 900,521.3 912.9,521.3		"/>
          <polygon class="st13" points="917.5,508.2 894.8,508.2 902.9,502.9 909.4,502.9		"/>
          <polyline class="st13" points="919.4,555.8 896.6,539.5 914,527.5		"/>
          <polyline class="st13" points="893.6,555.7 916.1,539.4 898.7,527.4		"/>
          <line class="st13" x1="910.4" y1="508.2" x2="900" y2="521.3"/>
          <line class="st13" x1="902.4" y1="508.2" x2="912.9" y2="521.3"/>
          <line class="st13" x1="917.5" y1="512.8" x2="917.5" y2="508.2"/>
          <line class="st13" x1="894.5" y1="512.8" x2="894.5" y2="508.2"/>
          <line class="st13" x1="919.6" y1="532.3" x2="919.6" y2="527.7"/>
          <line class="st13" x1="892.6" y1="532.3" x2="892.6" y2="527.7"/>
        </g>
      </g>
      <g>
        <clipPath id="SVGID_00000123420277437593912130000016416843335093897400_">
          <circle cx="865.1" cy="497.7" r="93.7"/>
        </clipPath>
          <path style="clip-path:url(#SVGID_00000123420277437593912130000016416843335093897400_);fill:none;stroke:#FBBA00;stroke-width:2;stroke-miterlimit:10;" d="
					M969.4,516.1c-7.8,12.7-52.2-2.8-52.2-2.8s-16.5-8.3-26.8-14.1c-22.6-12.7-35.2-24-35.2-24s-130,28.3-151,1.3"/>
      </g>
      <g>
        <clipPath id="SVGID_00000042702036564040398940000015674764820319069604_">
          <circle cx="865.1" cy="497.7" r="93.7"/>
        </clipPath>
          <path style="clip-path:url(#SVGID_00000042702036564040398940000015674764820319069604_);fill:none;stroke:#FBBA00;stroke-width:2;stroke-miterlimit:10;" d="
					M966.6,545.7c-12.6,1.4-46.5-12.7-46.5-12.7s-23-3.7-33.8-8.5c-25.4-11.3-26.8-12.7-26.8-12.7s-111.2,44.6-132.2,17.7"/>
      </g>
      <g>
        <circle class="st17" cx="865.1" cy="497.7" r="93.7"/>
      </g>
    </g>
  </g>

  @if (deviceMatrix.eigennutzung.visible) {
    <g style="transform: matrix(1, 0, 0, 1, 0, 40)">
      <!-- icon household -->
      <g>
        <g>
          <g>
            <defs>
              <circle id="SVGID_00000029738863574163993660000002063294217404417171_" cx="95" cy="497.7" r="93.7"/>
            </defs>
            <clipPath id="SVGID_00000007423833795179510990000002072268185478165639_">
              <use xlink:href="#SVGID_00000029738863574163993660000002063294217404417171_" style="overflow:visible;"/>
            </clipPath>
            <circle style="clip-path:url(#SVGID_00000007423833795179510990000002072268185478165639_);" class="st1" cx="95" cy="497.7" r="93.7"/>
          </g>
          <g>
            <defs>
              <circle id="SVGID_00000135677143685251244770000015508839694857166747_" cx="95" cy="497.7" r="93.7"/>
            </defs>
            <clipPath id="SVGID_00000182519778478463866720000003680293415734462616_">
              <use xlink:href="#SVGID_00000135677143685251244770000015508839694857166747_" style="overflow:visible;"/>
            </clipPath>
            <rect x="-1.5" y="543.6" style="clip-path:url(#SVGID_00000182519778478463866720000003680293415734462616_);" class="st0" width="224.2" height="128.8"/>
          </g>
        </g>
        <g>
          <path class="st1" d="M113.7,495.8H69.8c-6.6,0-12-5.4-12-12v-40.9c0-6.6,5.4-12,12-12h43.9c6.6,0,12,5.4,12,12v40.9
					C125.7,490.4,120.3,495.8,113.7,495.8z"/>
          <rect x="71.2" y="450.2" class="arrow" width="38.6" height="20.8"/>
          <g>
            <g id="Strom_00000067202554444524731270000009055439444552042644_">
              <g>
                <path class="st4" d="M59.7,497.8h63.1c2.7,0,4.8-2.1,4.8-4.6v-60.6c0-2.6-2.2-4.6-4.8-4.6H59.7c-2.7,0-4.8,2.1-4.8,4.6v60.6
								C54.8,495.7,57,497.8,59.7,497.8z M91.6,434c16.4,0,29.8,12.9,29.8,28.6s-13.4,28.6-29.8,28.6s-29.8-12.9-29.8-28.6
								S75.1,434,91.6,434z M114.7,457.9v-7.5c-3.9-6.5-10.8-11.3-19-12.3v4.5c0,1.9-1.5,3.3-3.5,3.3s-3.5-1.5-3.5-3.3v-4.7
								c-8.6,1-15.9,5.9-20,12.8c0,0.1,0.1,0.1,0.1,0.2v7.1h-3v10h3v6.8c4.1,6.7,11.4,11.5,20,12.5v-4.2c0-1.9,1.5-3.3,3.5-3.3
								s3.5,1.5,3.5,3.3v4.2c7.7-1,14.3-5.8,18-12.4V468h4v-10h-3.1V457.9z M79.8,466.7c-3.1,0-5.6-2.4-5.6-5.4s2.5-5.4,5.6-5.4
								s5.6,2.4,5.6,5.4C85.5,464.3,83,466.7,79.8,466.7z M103.3,466.7c-3.1,0-5.6-2.4-5.6-5.4s2.5-5.4,5.6-5.4s5.6,2.4,5.6,5.4
								C109,464.3,106.5,466.7,103.3,466.7z"/>
              </g>
            </g>
          </g>
        </g>
        <g>
          <g>
            <defs>
              <circle id="SVGID_00000080899884395215960470000003993538716834064007_" cx="95" cy="497.7" r="93.7"/>
            </defs>
            <clipPath id="SVGID_00000071554626418501847470000013968188246704091550_">
              <use xlink:href="#SVGID_00000080899884395215960470000003993538716834064007_" style="overflow:visible;"/>
            </clipPath>
            <g style="clip-path:url(#SVGID_00000071554626418501847470000013968188246704091550_);">
              <path class="st21" d="M-63.4,751.3c0,0,48.2-7.5,57.9-46.9s-3.7-53.1-13.3-55.1c-20.8-4.2-31.1,19.4-14.8,29.6
							c6.7,4.2,28.7,4.3,45.1-6.1c46.1-29.2,4.2-57.7,21.2-78.2s85.8,20.9,100.1-2.4s-20.7-43,0.3-61.1"/>
              <path class="st4" d="M146.3,498.6l8.7-10.3c0.7-0.9,2-1,2.9-0.3s1,2,0.3,2.9l-8.7,10.3l10.3,8.7l8.7-10.3c0.7-0.9,2-1,2.9-0.3
							s1,2,0.3,2.9l-8.7,10.3l3.6,3l-5.3,6.4c-4.8,5.8-12.9,7.1-19.3,3.7l-8.2,9.8l-4.8-4l8.2-9.8c-4.5-5.7-4.6-13.9,0.3-19.7
							l5.3-6.4L146.3,498.6z"/>
            </g>
          </g>
        </g>
      </g>
      <g>
        <path class="arrow" d="M42.7,495.9c-0.4-0.2-0.9-0.2-1.3,0.1l-5.6,4.1L35,486.7c0-0.4-0.3-0.8-0.7-1s-0.8-0.1-1.1,0.1l-8.7,6.3
				c-0.3,0.2-0.5,0.7-0.5,1.1l3.7,21.7c0.1,0.4,0.3,0.7,0.7,0.9c0.4,0.1,0.8,0.1,1.1-0.1l4.9-3.6l4.3,17.9c0.2,0.6,0.6,1,1.2,0.9
				c0.2,0,0.4-0.1,0.6-0.2c0.3-0.2,0.4-0.5,0.5-0.9l2.2-33C43.3,496.5,43.1,496.1,42.7,495.9z"/>
      </g>
    </g>
  }
</g>
<g>
  <g style="transform: matrix(1, 0, 0, 1, -90, 0)">
    <!-- main headline -->
    <circle class="arrow" cx="270" cy="119" r="27.5"/>
      <path class="white" d="M281.7,112.4c-0.2-0.4-0.6-0.7-1.1-0.7h-6.9l7.2-11.3c0.2-0.3,0.2-0.8,0-1.2c-0.2-0.4-0.6-0.6-1-0.6h-10.7
      c-0.4,0-0.8,0.3-1,0.6l-9.8,19.7c-0.2,0.3-0.2,0.8,0,1.1c0.2,0.3,0.6,0.5,1,0.5h6.1l-7.1,17c-0.2,0.6,0,1.1,0.5,1.4
      c0.2,0.1,0.4,0.2,0.6,0.2c0.3,0,0.7-0.2,0.9-0.4l21.3-25.3C281.8,113.3,281.9,112.8,281.7,112.4z"/>
  </g>
  <text x="240" y="128" class="bold headline" [innerHTML]="'photovoltaikcheck.ergebnis.image.anlage' | translate: placeholder"></text>
  <text x="450" y="128" class="headline" [innerHTML]="'photovoltaikcheck.ergebnis.image.anlage.werte' | translate: placeholder"></text>
</g>
<g>
  @if (deviceMatrix.eigennutzung.visible) {
    <g style="transform: translateY(20px)">
      <g>
        <polyline class="line" points="286.5,202.1 286.5,444.5 186.3,444.5"/>
        <polygon class="arrow" points="196.2,432.2 198.2,434.4 187.4,444.5 198.2,454.6 196.2,456.8 183,444.5"/>
      </g>
      <path class="st0" style="transform: matrix(1, 0, 0, 1, 20, 0)" d="M419,487H217c-6.6,0-12-5.4-12-12v-59c0-6.6,5.4-12,12-12h202c6.6,0,12,5.4,12,12v59
        C431,481.6,425.6,487,419,487z"/>
      <text x="240" y="432" class="bold" [innerHTML]="'photovoltaikcheck.ergebnis.image.eigennutzung' | translate: placeholder"></text>
      <text x="240" y="470" class="primary" [innerHTML]="'photovoltaikcheck.ergebnis.image.eigennutzung.wert' | translate: placeholder"></text>
    </g>
  }

  <!-- battery -->
  @if(deviceMatrix.eigennutzung.visible) {
    <g [style]="'transform: translate(' + (currentConfigurationType === 'individuell'? '25' : '0') + 'px, 85px)'" [class.disabled]="batterySize === 0">
      <path class="st0" style="transform: matrix(1, 0, 0, 1, 60, 0)" d="M282.7,704.9h-280c-6.6,0-12-5.4-12-12v-59c0-6.6,5.4-12,12-12h280c6.6,0,12,5.4,12,12v59
        C294.7,699.5,289.3,704.9,282.7,704.9z"/>
      <!-- icon -->
      <g>
        <g>
          <g>
            <defs>
              <ellipse id="SVGID_00000034808020383721640670000011378283406761643913_" transform="matrix(0.9997 -2.378930e-02 2.378930e-02 0.9997 -15.7697 1.2059)" cx="42.8"
                cy="663.4" rx="41.6" ry="41.6"/>
            </defs>
            <clipPath id="SVGID_00000133501704188215524770000016885231028805083581_">
              <use xlink:href="#SVGID_00000034808020383721640670000011378283406761643913_" style="overflow:visible;"/>
            </clipPath>
            <ellipse transform="matrix(0.9997 -2.378930e-02 2.378930e-02 0.9997 -15.7697 1.2059)"
              style="clip-path:url(#SVGID_00000133501704188215524770000016885231028805083581_);" class="st1" cx="42.8" cy="663.4" rx="41.6" ry="41.6"/>
          </g>
          <g>
            <defs>
              <ellipse id="SVGID_00000085230538395349920470000003304278179742215057_" transform="matrix(0.9997 -2.378930e-02 2.378930e-02 0.9997 -15.7697 1.2059)" cx="42.8"
                cy="663.4" rx="41.6" ry="41.6"/>
            </defs>
            <clipPath id="SVGID_00000015331540565458054740000007937231849127185578_">
              <use xlink:href="#SVGID_00000085230538395349920470000003304278179742215057_" style="overflow:visible;"/>
            </clipPath>
            <rect y="678.5" style="clip-path:url(#SVGID_00000015331540565458054740000007937231849127185578_);" class="st1" width="99.4" height="41.5"/>
          </g>
          <g>
            <ellipse id="SVGID_00000129174185287365698110000012066242181387936416_" transform="matrix(0.9997 -2.378930e-02 2.378930e-02 0.9997 -15.7697 1.2059)" class="st27"
              cx="42.8" cy="663.4" rx="41.6" ry="41.6"/>
          </g>
        </g>
        <g>
          <g>
            <g>
              <g>
                <rect x="20.2" y="644.7" class="st0" width="45.6" height="43.6"/>
                <rect x="20.2" y="685" class="st0" width="9" height="9"/>
              </g>
              <rect x="56.9" y="685" class="st0" width="9" height="9"/>
            </g>
            <rect x="20.2" y="635" class="st0" width="45.6" height="44.3"/>
            <rect x="20.2" y="645.6" class="st4" width="45.6" height="18.8"/>
            <rect x="20.2" y="665.4" class="st4" width="45.6" height="18.8"/>
            <circle class="st1" cx="23.4" cy="638.6" r="1.5"/>
            <circle class="st1" cx="27.3" cy="638.6" r="1.5"/>
          </g>
          <g>
            <ellipse transform="matrix(0.9999 -1.020250e-02 1.020250e-02 0.9999 -6.7773 0.4733)" class="st1" cx="43" cy="664.5" rx="13.4" ry="13.4"/>
            <g>
              <polygon class="st4" points="50.3,666.5 50.3,666.6 51.7,666.6 51.7,662.3 50.3,662.3 50.3,662.4 48.3,660.2 34.3,660.2
						34.3,668.7 48.3,668.7		"/>
              <rect x="35.4" y="661.1" class="arrow" width="3.3" height="6.7"/>
              <rect x="39.6" y="661.1" class="arrow" width="3.3" height="6.7"/>
              <rect x="43.8" y="661.2" class="arrow" width="3.3" height="6.7"/>
            </g>
          </g>
        </g>
      </g>
      <text x="115" y="652" class="bold" [innerHTML]="'photovoltaikcheck.ergebnis.image.batteriespeicher' | translate: placeholder"></text>
      <text x="115" y="690" class="primary"
      [innerHTML]="'photovoltaikcheck.ergebnis.image.batteriespeicher.wert' | translate: placeholder"></text>
    </g>
  }
  @if (deviceMatrix.volleinspeisung.visible) {
    <g style="transform: translateY(20px)">
      <g>
        <!-- line netzeinspeisung -->
        <polyline class="line" points="585.5,202.1 585.5,445 781.7,445"/>
        <polygon class="arrow" points="771.8,457.3 769.8,455.1 780.6,445 769.8,434.9 771.8,432.7 785,445	"/>
      </g>
      <path class="st0" style="transform: translatex(40px)" d="M695,489H471c-6.6,0-12-5.4-12-12v-59c0-6.6,5.4-12,12-12h224c6.6,0,12,5.4,12,12v59
        C707,483.6,701.6,489,695,489z"/>
      <text x="510" y="432" class="bold" [innerHTML]="'photovoltaikcheck.ergebnis.image.netzeinspeisung' | translate: placeholder"></text>
      <text x="510" y="470" class="primary"
      [innerHTML]="'photovoltaikcheck.ergebnis.image.netzeinspeisung.wert' | translate: placeholder"></text>
    </g>
  }
  @if (deviceMatrix.eigennutzung.visible) {
    <g style="transform: translateY(40px)">
      <path class="st0" d="M694.9,595.6h-184c-6.6,0-12-5.4-12-12v-59c0-6.6,5.4-12,12-12h184c6.6,0,12,5.4,12,12v59
		C706.9,590.2,701.5,595.6,694.9,595.6z"/>
      <text x="510" y="540" class="bold" [innerHTML]="'photovoltaikcheck.ergebnis.image.stromzukauf' | translate: placeholder"></text>
      <text x="510" y="578" class="primary" [innerHTML]="'photovoltaikcheck.ergebnis.image.stromzukauf.wert' | translate: placeholder"></text>
    </g>
  }
  @if (deviceMatrix.eigennutzung.visible) {
    <g style="transform: translateY(85px)">
      <path style="transform: scaleX(1.2); transform-origin: center" class="st0" d="M779.7,704.6h-268c-6.6,0-12-5.4-12-12v-59c0-6.6,5.4-12,12-12h268c6.6,0,12,5.4,12,12v59
		C791.7,699.2,786.3,704.6,779.7,704.6z"/>
      <text x="515" y="652" class="bold"
      [innerHTML]="'photovoltaikcheck.ergebnis.image.ueberschusseinspeisung' | translate: placeholder"></text>
      <text x="515" y="690" class="primary" [innerHTML]="'photovoltaikcheck.ergebnis.image.ueberschusseinspeisung.wert' | translate: placeholder"></text>
    </g>
  }
</g>
<g>
  <!-- device parts -->
  <rect x="100" y="160" class="st0 anlage-background" [attr.width]="AREA_WIDTH_MAX" height="120"/>
  @if(deviceMatrix.eigennutzung.width > 0) {
    <rect [class.drag]="!!dragElement" [attr.x]="deviceMatrix.eigennutzung.x" y="160" class="anlage-eigennutzung" [attr.width]="deviceMatrix.eigennutzung.width" height="120"/>
    <!-- texts for the device part eigennutzung -->
    <text [class.drag]="!!dragElement" [attr.x]="deviceMatrix.eigennutzung.x + 20" y="214" class="headline white" [innerHTML]="'photovoltaikcheck.ergebnis.image.eigennutzung.werte' | translate: placeholder"></text>
    <text [class.drag]="!!dragElement" [attr.x]="deviceMatrix.eigennutzung.x + 20" y="257" class="subheadline white bold" [innerHTML]="'photovoltaikcheck.ergebnis.image.eigennutzung' | translate: placeholder"></text>
  }

  @if(deviceMatrix.volleinspeisung.width > 0) {
    <rect [class.drag]="!!dragElement" [attr.x]="deviceMatrix.volleinspeisung.x" y="160" class="anlage-volleinspeisung" [attr.width]="deviceMatrix.volleinspeisung.width" height="120"/>
    <!-- texts for the device part volleinspeisung -->
    <text [class.drag]="!!dragElement" [attr.x]="deviceMatrix.volleinspeisung.x + 20" y="214" class="headline white" [innerHTML]="'photovoltaikcheck.ergebnis.image.volleinspeisung.werte' | translate: placeholder"></text>
    @if(deviceMatrix.volleinspeisung.width >= AREA_MIN_WITH) {
      <text [class.drag]="!!dragElement" [attr.x]="deviceMatrix.volleinspeisung.x + 20" y="257" class="bold subheadline white" [innerHTML]="'photovoltaikcheck.ergebnis.image.volleinspeisung' | translate: placeholder"></text>
    }
  }

  @if(currentConfigurationType === OPTIMIERUNG_INDIVIDUELL || currentConfigurationType === OPTIMIERUNG_VOLLEINSPEISUNG) {
    <!-- thumb feed in -->
    <g
      [tabindex]="isHidden? '-1' : '0'"
      role="slider"
      aria-orientation="horizontal"
      [attr.aria-label]="('photovoltaikcheck.ergebnis.image.volleinspeisung' | translate: placeholder) + ': ' + ('photovoltaikcheck.ergebnis.image.volleinspeisung.werte' | translate: placeholder)"
      [attr.aria-valuenow]="'photovoltaikcheck.ergebnis.image.volleinspeisung.werte' | translate: placeholder"
      [attr.transform]="'matrix(1.2,0,0,1.2,' + thumbs.feedin.x + ',' + (currentConfigurationType === OPTIMIERUNG_INDIVIDUELL? '-580' : '-610') + ')'"
      (touchstart)="startDrag($event, 'feedin')"
      (mousedown)="startDrag($event, 'feedin')"
      (keyup)="handleSliderKeydown('feedin', $event)"
      >
      <path class="resize" d="m 1283.4958,672.76154 c -11.855,0 -21.5,9.645 -21.5,21.5 0,11.855 9.645,21.5 21.5,21.5 11.855,0 21.5,-9.645 21.5,-21.5 0,-11.855 -9.645,-21.5 -21.5,-21.5"/>
      <path class="resize-background" d="m 1281.5441,681.78754 -14.915,12.474 14.915,12.474 z"/>
      <path class="resize-background" d="m 1285.4477,706.73514 14.915,-12.474 -14.915,-12.474 z"/>
    </g>
  }
  @if(currentConfigurationType === 'individuell') {
    <!-- thumb own use -->
    <g
      [tabindex]="isHidden? '-1' : '0'"
      role="slider"
      aria-orientation="horizontal"
      [attr.aria-label]="('photovoltaikcheck.ergebnis.image.eigennutzung' | translate: placeholder) + ': ' + ('photovoltaikcheck.ergebnis.image.eigennutzung.werte' | translate: placeholder)"
      [attr.aria-valuenow]="'photovoltaikcheck.ergebnis.image.eigennutzung.werte' | translate: placeholder"
      [attr.transform]="'matrix(1.2,0,0,1.2,' + thumbs.ownuse.x + ',-650)'"
      (touchstart)="startDrag($event, 'ownuse')"
      (mousedown)="startDrag($event, 'ownuse')"
      (keyup)="handleSliderKeydown('ownuse', $event)"
      >
      <path class="thumb-background" d="m 1283.4958,672.76154 c -11.855,0 -21.5,9.645 -21.5,21.5 0,11.855 9.645,21.5 21.5,21.5 11.855,0 21.5,-9.645 21.5,-21.5 0,-11.855 -9.645,-21.5 -21.5,-21.5"/>
      <path class="thumb" d="m 1281.5441,681.78754 -14.915,12.474 14.915,12.474 z"/>
      <path class="thumb" d="m 1285.4477,706.73514 14.915,-12.474 -14.915,-12.474 z"/>
    </g>

    @if(batterySize >= batteryMin) {
      <g
        [tabindex]="isHidden? '-1' : '0'"
        role="button"
        transform="matrix(1.6,0,0,1.6,-1661,-655)"
        (click)="resizeBattery('-', $event)"
        (keydown.space)="resizeBattery('-', $event)"
        (keydown.enter)="resizeBattery('-', $event)"
        >
        <path class="resize-background" d="m 1065.4722,878.59234 c 0,-7.487 -6.069,-13.556 -13.556,-13.556 -7.487,0 -13.556,6.069 -13.556,13.556 0,7.487 6.069,13.556 13.556,13.556 7.487,0 13.556,-6.069 13.556,-13.556 z"/>
        <path class="resize" d="m 1043.9061,880.74934 h 16.021 v -4.313 h -16.021 z"/>
      </g>
    }
    @if(batterySize < batteryMax) {
      <g
        [tabindex]="isHidden? '-1' : '0'"
        role="button"
        transform="matrix(1.6,0,0,1.6,-1713,-655)"
        (click)="resizeBattery('+', $event)"
        (keydown.space)="resizeBattery('+', $event)"
        (keydown.enter)="resizeBattery('+', $event)"
        >
        <path class="resize-background" d="m 1154.6985,878.59234 c 0,-7.487 -6.069,-13.556 -13.556,-13.556 -7.487,0 -13.556,6.069 -13.556,13.556 0,7.487 6.069,13.556 13.556,13.556 7.487,0 13.556,-6.069 13.556,-13.556"/>
        <path class="resize" d="m 1143.2991,870.58234 h -4.313 v 16.021 h 4.313 z"/>
        <path class="resize" d="m 1133.1321,880.74934 h 16.021 v -4.313 h -16.021 z"/>
      </g>
    }

  }
</g>
</svg>
